import window from 'window-or-global';
import { logAnalytics } from '../editor-analytics/analytics';

const insertTable = (editor, cols, rows, heading) => {
	const Env = window.tinymce.Env;
	let y, x, html, tableElm, firstCell;
	const padding = Env.ie && Env.ie < 10 ? '&nbsp;' : '<br data-mce-bogus="1">';

	html = '<table id="__mce" class="confluenceTable"><tbody>';

	for (y = 0; y < rows; y++) {
		const isHeadingRow = y === 0 && heading;
		const cellClassName = isHeadingRow ? 'confluenceTh' : 'confluenceTd';
		html += '<tr>';

		for (x = 0; x < cols; x++) {
			if (isHeadingRow) {
				html += `<th class=${cellClassName}>${padding}</th>`;
			} else {
				html += `<td class=${cellClassName}>${padding}</td>`;
			}
		}

		html += '</tr>';
	}

	html += '</tbody></table>';

	editor.undoManager.transact(() => {
		editor.insertContent(html);

		tableElm = editor.dom.get('__mce');
		editor.dom.setAttrib(tableElm, 'id', null);

		editor.$('tr', tableElm).each((index, row) => {
			editor.fire('newrow', {
				node: row,
			});

			editor.$('th,td', row).each((index, cell) => {
				firstCell = firstCell || cell;

				editor.fire('newcell', {
					node: cell,
				});
			});
		});

		editor.dom.setAttribs(tableElm, editor.settings.table_default_attributes || {});
		editor.dom.setStyles(tableElm, editor.settings.table_default_styles || {});
	});

	editor.selection.select(firstCell, true);
	editor.selection.collapse(true);

	return tableElm;
};

const setup = (editor) => {
	editor.addCommand('confInsertTable', (ui, details) => {
		insertTable(editor, details.cols, details.rows, details.heading);
		logAnalytics('insert.table');
	});
};

export default { setup };
